export default "__VITE_ASSET__DDnQQsoj__"